var map = {
	"./logo": 50,
	"./logo-tdc": 214,
	"./logo-tdc.png": 214,
	"./logo.jpg": 365,
	"./logo.png": 50,
	"./logoDevbot-blue": 215,
	"./logoDevbot-blue.png": 215,
	"./logoDevbot-white": 216,
	"./logoDevbot-white.png": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;